import React, { useEffect, useState } from 'react'
import { subscribe } from 'react-contextual'
import { Button } from 'components'
import CsvIcon from 'components/atoms/Icons/Doc/Csv'
import EmailIcon from 'components/atoms/Icons/Doc/Email'
import PdfIcon from 'components/atoms/Icons/Doc/PdfAlt'
import { downloadBase64 } from 'utils/fileUtils'
import { $TSFixMe } from 'types/ts-migrate'
import ViewStatementProvider from '../ViewStatementProvider'
import styles from './ViewStatementActions.module.scss'

const EMAIL_UNAVAILABLE = 'Emailing statements is not available yet'

interface ViewStatementActionsProps extends $TSFixMe {
  pdfFileName: string
  csvFileName: string
  startDate: string
  endDate: string
}

const ViewStatementActions = ({
  downloadStatement,
  downloadStatementCsv,
  statementPdf,
  statementCsv,
  pdfFileName,
  csvFileName,
  startDate,
  endDate,
}: ViewStatementActionsProps): React.ReactElement => {
  const [requestedPdfDownload, setRequestedPdfDownload] = useState(false)
  useEffect(() => {
    if (statementPdf && requestedPdfDownload) {
      const fileName = `${pdfFileName}_${startDate}_${endDate}.pdf`
      statementPdf && downloadBase64(statementPdf, 'application/pdf', fileName)
      setRequestedPdfDownload(false)
    }
  }, [statementPdf, pdfFileName, requestedPdfDownload, startDate, endDate])

  const [requestedCsvDownload, setRequestedCsvDownload] = useState(false)
  useEffect(() => {
    if (statementCsv && requestedCsvDownload) {
      const fileName = `${csvFileName}_${startDate}_${endDate}.csv`
      statementCsv && downloadBase64(statementCsv, 'text/csv', fileName)
      setRequestedCsvDownload(false)
    }
  }, [statementCsv, csvFileName, requestedCsvDownload, startDate, endDate])

  return (
    <div className={styles.actions}>
      <Button
        size="sm"
        ghost
        className={styles.action}
        loading={requestedPdfDownload}
        disabled={!downloadStatement}
        onClick={() => {
          setRequestedPdfDownload(true)
          downloadStatement(startDate, endDate)
        }}
      >
        <PdfIcon width={22} height={22} aria-hidden />
        PDF
      </Button>

      {downloadStatementCsv && (
        <Button
          size="sm"
          ghost
          className={styles.action}
          loading={requestedCsvDownload}
          disabled={!downloadStatementCsv}
          onClick={() => {
            setRequestedCsvDownload(true)
            downloadStatementCsv(startDate, endDate)
          }}
        >
          <CsvIcon width={22} height={22} aria-hidden />
          CSV
        </Button>
      )}

      {/* Hide this until its available */}
      {/* <Button size="sm" ghost className={styles.action} disabled title={EMAIL_UNAVAILABLE}>
        <EmailIcon width={22} height={22} aria-hidden />
        Email
      </Button> */}
    </div>
  )
}

export default subscribe(
  [ViewStatementProvider],
  ({
    downloadStatement,
    downloadStatementCsv,
    statementPdf,
    statementCsv,
    pdfFileName,
    csvFileName,
    startDate,
    endDate,
  }: any) => ({
    downloadStatement,
    downloadStatementCsv,
    statementPdf,
    statementCsv,
    pdfFileName,
    csvFileName,
    startDate,
    endDate,
  }),
)(ViewStatementActions)
